import { render, staticRenderFns } from "./script-view.vue?vue&type=template&id=2b61c33c&scoped=true&"
import script from "./script-view.vue?vue&type=script&lang=js&"
export * from "./script-view.vue?vue&type=script&lang=js&"
import style0 from "./script-view.vue?vue&type=style&index=0&id=2b61c33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61c33c",
  null
  
)

export default component.exports